import { Configuration, IConfiguration } from './domain/conf'
import adTargetLookup from './domain/conf/ads/targeting/lookup.json'
import { Page } from './domain/page'
import { AdService, IAdTargetingConfig } from './services/ads'
import { GPTAdapter } from './services/ads/adapters/main/gpt'
import integralAdScience from './services/ads/adapters/vendors/ad-verifier/integral-ad-science'
import { defaultAdURIFormatter } from './services/ads/formatters/default'
import { DefaultAdTargetingStrategy } from './services/ads/targeting/default'
import { AgeGateService } from './services/age-gate'
import { PageAgeGateService } from './services/age-gate/page'
import { AnalyticsService } from './services/analytics'
import { EventAdapter } from './services/analytics/adapters/events'
import { TagManager } from './services/analytics/tags'
import { ConsentBannerService } from './services/consent-banner'
import { IdentityService } from './services/identity'
import { RecommendationsService } from './services/recommendations'
import { logger, loggerTimeLog, loggerTimer, TimerLabels } from './utils/common/logger'
import { GlobalStore } from './utils/storage/global'
import { Store } from './utils/storage/keys'

export const initPage: (conf: IConfiguration) => Page = (conf: IConfiguration) => {
    loggerTimer(TimerLabels.PAGE_LOAD)
    logger('debug', `${TimerLabels.PAGE_LOAD} - initPage called`)
    loggerTimeLog(TimerLabels.PAGE_LOAD)
    if (conf.ads.verifier) {
        integralAdScience.initializeVerifier(conf.ads.verifier)
    }
    const page = new Page(new Configuration(conf),
        new AdService(
            GPTAdapter.getInstance(conf),
            defaultAdURIFormatter,
            new DefaultAdTargetingStrategy(adTargetLookup)),
        new AgeGateService(),
        new PageAgeGateService(),
        new ConsentBannerService(),
        new RecommendationsService(),
        new AnalyticsService(
            new EventAdapter(),
            new TagManager()),
        new IdentityService())

    page.init().catch((err) => {
        logger('error', 'initPage failed: ', err)
    })
    return page
}

/**
 * Returns Ad Targeting Config  (To be used in Youtube Player)
 */
export const getAdTargetingConfig = async (configuration: IConfiguration): Promise<IAdTargetingConfig> => {
    const conf = new Configuration(configuration)
    const adService = new AdService(
        GPTAdapter.getInstance(conf),
        defaultAdURIFormatter,
        new DefaultAdTargetingStrategy(adTargetLookup))
    return await adService.getTargeting({
        ancestry: conf.ads.ancestry,
        articleId: conf.page.articleId,
        bidding: conf.ads.bidding,
        negative: conf.page.klangoo ? conf.page.klangoo.negativeKeywords : undefined,
        network: conf.ads.network,
        originId: conf.page.originId,
        page: conf.ads.type,
        pageConfig: conf.page,
        property: conf.ads.property,
        provider: conf.ads.provider,
        refresh: conf.ads.refresh,
        sensitive: conf.page.klangoo ? conf.page.klangoo.sensitiveContent : undefined,
        siteId: conf.ads.site,
        topics: conf.ads.topics,
        verifier: conf.ads.verifier,
        writers: conf.page.writers
    }).catch((error) => {
        logger('error', `video ad targeting error - getTargeting: ${error}`)
        return {}
    })

}
export { GlobalStore, Store }
